"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isDateOutOfHours = exports.getDateString = exports.getCurrentAustraliaDate = void 0;
var dayjs_1 = __importDefault(require("dayjs"));
var getCurrentAustraliaDate = function (date) {
    // convert to milliseconds, add local time zone offset and get UTC time in milliseconds
    var utcTime = date.getTime() + date.getTimezoneOffset() * 60000;
    // time offset for Australia is +10
    var timeOffset = 10;
    // create new Date object for a different timezone using supplied its GMT offset.
    var currentAustraliaTime = new Date(utcTime + 3600000 * timeOffset);
    return currentAustraliaTime;
};
exports.getCurrentAustraliaDate = getCurrentAustraliaDate;
var getDateString = function (date, format) {
    if (!date) {
        throw new Error('getDateString need a date');
    }
    if (format) {
        return (0, dayjs_1.default)(date).format(format);
    }
    return date.toString();
};
exports.getDateString = getDateString;
var isDateOutOfHours = function (currentDate, _a) {
    var australiaPublicHolidays = _a.australiaPublicHolidays, australiaStartBusinessHoursTime = _a.australiaStartBusinessHoursTime, australiaEndBusinessHoursTime = _a.australiaEndBusinessHoursTime, australiaWorkingDays = _a.australiaWorkingDays;
    var currentAustraliaTime = (0, exports.getCurrentAustraliaDate)(currentDate);
    var date = (0, dayjs_1.default)(currentAustraliaTime).format('DD/MM/YYYY');
    if (australiaPublicHolidays.includes(date)) {
        return true;
    }
    var australiaStartBusinessHoursTimeArray = australiaStartBusinessHoursTime.split(':');
    var australiaEndBusinessHoursTimeArray = australiaEndBusinessHoursTime.split(':');
    var startTime = (0, dayjs_1.default)(currentAustraliaTime)
        .hour(australiaStartBusinessHoursTimeArray[0])
        .minute(australiaStartBusinessHoursTimeArray[1])
        .second(0)
        .toDate();
    var endTime = (0, dayjs_1.default)(currentAustraliaTime)
        .hour(australiaEndBusinessHoursTimeArray[0])
        .minute(australiaEndBusinessHoursTimeArray[1])
        .second(0)
        .toDate();
    var dayName = (0, dayjs_1.default)(currentAustraliaTime).format('dddd');
    if (currentAustraliaTime >= startTime && endTime >= currentAustraliaTime && australiaWorkingDays.includes(dayName)) {
        return false;
    }
    return true;
};
exports.isDateOutOfHours = isDateOutOfHours;
//# sourceMappingURL=dates.js.map